import type { WechatNotice } from './protocol';

const zh = {
  title: '微信登录',
  bindTitle: '绑定微信',
  description: '用微信扫一扫，在手机上确认。',
  prepare: '正在准备微信登录…',
  refresh: '刷新二维码',
  window: '在安全窗口继续',
  windowPending: '请在已打开的安全窗口完成本次验证。',
  help: '若二维码无法显示，可以在安全窗口继续。',
  other: '使用手机号或密码',
  retry: '重新准备微信登录',
  mobile: '请在电脑上使用微信扫码，或使用手机号与密码登录。',
  unavailable: '微信登录暂不可用，请稍后再试。',
  notices: {
    unavailable: '微信登录暂不可用，请稍后再试。',
    expired: '本次微信登录已过期，请重新开始。',
    conflict: '本次账号或微信关联状态已变化，请返回原页面重新确认。',
    cancelled: '你已取消微信授权，可以重新开始或使用其他方式。',
    'popup-blocked': '安全窗口未能打开，请主动重试，或使用手机号与密码。',
  },
};
const en: typeof zh = {
  title: 'Sign in with WeChat',
  bindTitle: 'Link WeChat',
  description: 'Scan with WeChat and confirm on your phone.',
  prepare: 'Preparing WeChat sign-in…',
  refresh: 'Refresh QR code',
  window: 'Continue in a secure window',
  windowPending: 'Finish this verification in the secure window you opened.',
  help: 'If the QR code does not appear, continue in a secure window.',
  other: 'Use phone or password',
  retry: 'Prepare WeChat sign-in again',
  mobile: 'Scan with WeChat on a computer, or use your phone or password to sign in.',
  unavailable: 'WeChat sign-in is temporarily unavailable. Please try again.',
  notices: {
    unavailable: 'WeChat sign-in is temporarily unavailable. Please try again.',
    expired: 'This WeChat sign-in expired. Please start again.',
    conflict: 'Your account or WeChat link changed. Return to the original page and check again.',
    cancelled: 'WeChat authorization was cancelled. Start again or use another method.',
    'popup-blocked': 'The secure window could not open. Try again, or use your phone or password.',
  },
};
export const wechatCopy = (locale = 'zh-CN') => (locale.startsWith('zh') ? zh : en);
export const wechatNotice = (notice: WechatNotice, locale = 'zh-CN') =>
  wechatCopy(locale).notices[notice];
